//angular imports
import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

//local imports
import { Persona } from '../_enums/persona';
import { AppConfig } from '../app-config';
import { getCookie, setCookie } from '../_helpers/cookies';

@Injectable({
  providedIn: 'root'
})
export class PersonaService {
  public currentPersona = signal<Persona>(null);
  public allPersonas = signal<Persona[]>([]);

  private personasLoaded = new BehaviorSubject<boolean>(false);
  private personaChanged = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private applicationConfig: AppConfig,
    private authenticationService: MsalService,
  ) {
    this.http.get<Persona[]>(`${this.applicationConfig.applicationUri}/v2/user/persona`)
      .subscribe((personaList) => {
        if (personaList.length > 0) {
          this.allPersonas.set(personaList);
          let personaCookie = getCookie('persona');
          if (personaCookie != null) {
            let persona = Number(personaCookie);
            if (personaList.includes(persona)) this.currentPersona.set(persona);
            else this.currentPersona.set(personaList[0]);
          } else this.currentPersona.set(personaList[0]);
          this.personasLoaded.next(true);
        }
      });
/*
    var currentUser = this.authenticationService.instance.getActiveAccount();
    if (currentUser !== undefined) {
      const claims = currentUser.idTokenClaims['personas'] as string[];
      if (claims !== undefined) {
        const personaList: Persona[] = [];
        for (const claim of claims) {
          const num = parseInt(claim, 10);
          if (!isNaN(num) && num > 0 && Persona[num] !== undefined) {
            let persona: Persona = num as Persona;
            personaList.push(persona);
          }
        }
        this.allPersonas.set(personaList);
        if (personaList.length > 0) {
          let personaCookie = getCookie('persona');
          if (personaCookie != null) {
            let persona = Number(personaCookie);
            if (personaList.includes(persona)) this.currentPersona.set(persona);
            else this.currentPersona.set(personaList[0]);
          } else this.currentPersona.set(personaList[0]);
        }
        this.personasLoaded.next(true);
      }
    }*/
  }

  public setPersona(p: Persona) {
    this.currentPersona.set(p);
    this.personaChanged.next(true);
    setCookie('persona', '' + p, 365);
  }

  public changed() {
    return this.personaChanged.asObservable();
  }

  public initialized() {
    return this.personasLoaded.asObservable();
  }
}